<template>
  <div class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-narrow">
            <b-input :placeholder="$t('general.button.search')" type="search" icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('emplacement.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="getFilteredNumber > 0 ? '' : 'is-invisible'">
                  ({{ getFilteredNumber }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div v-if="!isSelectable" class="column is-narrow">
          <exportExcelButton
            :perm="emplacementPerm.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" class="has-text-centered" slot-scope="props">
        <qd-checkbox v-model="props.row.selected" :value="props.row"
                    @input="selectionEmplacement()"></qd-checkbox>
      </div>
      <div slot="addSelection" slot-scope="props">
        <b-tooltip :label="$t(getSelectionButtonMessage(props.row))"
                   :type="getSelectionButtonColor(props.row)">
          <button
            @click="$emit(
              isInSelection(props.row) ? 'removeSelection' : 'addSelection',
              [props.row],
            )"
            class="ripple button width-100percent"
            :class="getSelectionButtonColor(props.row)">
            <b-icon icon="plus-circle"></b-icon>
          </button>
        </b-tooltip>
      </div>
      <div slot="code" slot-scope="props" class="is-pulled-left">
        <router-link :to="{ name: switchDetailEmplacement(props.row),
              params: {id: props.row.id}}" class="lien"
                     :class="{'text-access-no-permission':
                                   !checkPermissions(emplacementPerm.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="type" slot-scope="props" class="is-pulled-left">
        {{ $t(getTypeEmplacement(props.row.type)) }}
      </div>
      <div slot="domaine" slot-scope="props" class="is-pulled-left">
        {{ $t(getDomaine(props.row)) }}
      </div>
      <div slot="libelle" slot-scope="props" class="is-pulled-left">
        {{ props.row.libelle }}
      </div>
      <div slot="adresseCadastrale.adresse1" slot-scope="props" class="is-pulled-left">
        {{ importFunction.adressFullStringGetter(props.row.adresseCadastrale) }}
      </div>
      <div slot="actif" slot-scope="props">
        {{ props.row.actif ? $t('general.non') : $t('general.oui') }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId) }}
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <btn-action-icon
          :tooltip-label="$t('general.button.edit')"
          :permission="emplacementPerm.maj"
          @is-click="modificationEmplacement(props.row)"
          icon-type="is-success"
          icon="pencil-box-outline">
        </btn-action-icon>
      </div>
      <div slot="archiver" slot-scope="props" class="has-text-centered">
        <btn-action-icon
          :tooltip-label="props.row.actif
            ? $t('general.button.archiver') : $t('general.button.desarchiver')"
          :permission="emplacementPerm.supprimer"
          @is-click="showPopUpArchivage(props.row)"
          icon-type="is-default"
          :icon="props.row.actif ? 'archive' : 'archive-arrow-up'">
        </btn-action-icon>
      </div>
      <div slot="delete" slot-scope="props" class="has-text-centered">
        <btn-action-icon
          :tooltip-label="$t('general.button.delete')"
          :permission="emplacementPerm.supprimer"
          @is-click="showPopUpSuppression(props.row)"
          icon-type="is-danger"
          icon="delete-forever">
        </btn-action-icon>
      </div>
      <div slot="showTree" slot-scope="props" class="has-text-centered">
        <btn-action-icon
          :tooltip-label="$t('general.button.afficher')"
          :permission="emplacementPerm.lecture"
          @is-click="goToTree(props.row)"
          icon-type="is-info"
          icon="file-tree">
        </btn-action-icon>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-emplacement @toggleFiltre="setShowFiltre" ref="filtreListeEmplacement"
                              @recherche="makeRechercheFilter"
                              :critereRecherche="critereRecherche"/>
      </div>
    </transition>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="900">
      <router-view class="componentStructure"></router-view>
    </transition>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal" @close="emplacementToArchive = null">
      <pop-up-prevention
        v-if="emplacementToArchive"
        @no="openPopUpPrevention = false; emplacementToArchive = null"
        @yes="archiverEmplacement"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('emplacement.archivageDesarchiver.'
        + (emplacementToArchive.actif ? 'archivage' : 'desarchivage')))"
        :mess-footer="$t(('emplacement.infoArchivageDesarchivage.'
        + (emplacementToArchive.actif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpPreventionSuppression"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="emplacementToDelete"
        @no="openPopUpPreventionSuppression = false, emplacementToDelete = null;"
        @yes="supprimerEmplacement"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t('emplacement.supprimer.titre')"
        :mess-footer="$t('emplacement.supprimer.sousTitre')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { EMPLACEMENT as emplacementPermission } from '@/configuration/gabed/permissionsGabedConf';
import inProgress from '@/services/general/inProgress';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import {
  PARKING, ADRESSE, CENTRE_COMMERCIAL, TYPE_EMPLACEMENT, LIGNE_BUS, TYPE_DONNEE_EMPLACEMENT,
  CLIENT, EMPLACEMENT, DISPOSITIF, MATERIEL, FACE,
} from '@/configuration/gabed/emplacement/emplacementConf';
import { EPHEMERAL_EMPLACEMENT_STORE, SELECTION_STATE } from '@/configuration/gabed/patrimoine/patrimoineConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import TableItemsInView from '@/components/general/TableItemsInView';
import filtreEmplacement from '@/components/gabed/emplacement/filtreEmplacement';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import { archiver, supprimer } from '@/api/gabed/emplacement';
import validationSuppression from '@/services/gabed/emplacement/validationSuppression';
import messageSucces from '@/services/general/messageSucces';
import validationEmplacement from '@/services/gabed/emplacement/validationEmplacement';
import { columnsSplice } from '@/services/general/columns';
import popUpPrevention from '@/components/general/popUpPrevention';
import { DOMAINE_EMPLACEMENT } from '@/configuration/gabed/emplacement/emplacementAdresseConf';
import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { REFERENCE_TABLE_EMPLACEMENT } from '@/configuration/general/referenceTableConf';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { get } from '@/api/tiers/index';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { getSelectionMessage, getSelectionColor } from '@/services/gabed/patrimoine/patrimoineSelection';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'l_emplacement',
  props: {
    isSelectable: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Object,
      required: false,
    },
    typePatrimoineSelected: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        EPHEMERAL_EMPLACEMENT_STORE,
        SELECTION_STATE,
        EMPLACEMENT,
        DISPOSITIF,
        MATERIEL,
        FACE,
      },
      emplacementPerm: emplacementPermission,
      ligneBus: LIGNE_BUS,
      allEmplacementSelected: false,
      emplacementSelectionne: false,
      showFiltre: false,
      importFunction: {
        adressFullStringGetter,
      },
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      errorPopUp: false,
      emplacementToArchive: null,
      emplacementToDelete: null,
      openPopUpPrevention: false,
      openPopUpPreventionSuppression: false,
      messagesErreurPopUp: [],
      referenceTable: REFERENCE_TABLE_EMPLACEMENT,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    TableItemsInView,
    filtreEmplacement,
    popUpPrevention,
    parametrageTable,
    exportExcelButton,
    BtnActionIcon,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    storeName() {
      return this.isSelectable ? this.constantes.EPHEMERAL_EMPLACEMENT_STORE : 'emplacement';
    },
    emplacements() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    total() {
      return this.$store.getters[`${this.storeName}/total`];
    },
    critereRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/critereRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE_RECHERCHE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    allInSelection() {
      return this.emplacements.every(p => this.selection.emplacements.find(s => s.id === p.id));
    },
    getFilteredNumber() {
      const banCritere = ['auto', 'actif', 'avecCoordonnees'];
      if (this.societeActive.agences.length === 1) banCritere.push('agencesId');
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      nbCritere += this.critereRecherche.actif !== null ? 1 : 0;
      nbCritere += this.critereRecherche.avecCoordonnees !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    iconSelectTotal() {
      if (this.allEmplacementSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = ['addSelection', 'selected', 'code', 'type', 'domaine', 'libelle', 'adresseCadastrale.adresse1', 'actif', 'agence', 'showTree', 'edit', 'archiver', 'delete'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      if (this.isSelectable) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'showTree');
        columnsSplice(columns, 'edit');
        columnsSplice(columns, 'archiver');
        columnsSplice(columns, 'delete');
      } else {
        columnsSplice(columns, 'addSelection');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('emplacement.code'),
          type: this.$i18n.t('emplacement.type'),
          domaine: this.$i18n.t('emplacement.domaine'),
          libelle: this.$i18n.t('emplacement.libelle'),
          'adresseCadastrale.adresse1': this.$i18n.t('emplacement.adresse'),
          actif: this.$i18n.t('emplacement.archive'),
          agence: this.$i18n.t('emplacement.agence'),
          showTree: '',
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          addSelection: (h) => {
            return h(
              'button', {
                attrs: {
                  class: `ripple button width-100percent ${this.allInSelection ? 'is-success' : 'is-primary'}`,
                },
                on: {
                  click: () => {
                    this.manageAllInSelection();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: 'plus-circle',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          if (this.critereRecherche.agencesId.length === 0) {
            this.critereRecherche.agencesId = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.critereRecherche);
          data.query.clientIds = tagInputToArray(this.critereRecherche.clients, 'id');
          delete data.query.clients;
          data.query.auto = this.critereRecherche.auto;
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadEmplacement(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.emplacements,
            count: this.total,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          showTree: 'colonneSelected',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archiver: 'colonneSelected',
          addSelection: 'colonneSelected',
        },
        sortable: ['code', 'type', 'libelle', 'domaine', 'adresseCadastrale.adresse1'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: TYPE_DONNEE_EMPLACEMENT,
        Filtres: this.lastPayload,
      };
    },
  },
  methods: {
    actionsLoadEmplacement(data) {
      return this.$store.dispatch(`${this.storeName}/loadEmplacement`, data);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeEmplacement.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeEmplacement.initializeFiltre();
      this.$refs.filtreListeEmplacement.viderCritere();
      this.$refs.filtreListeEmplacement.appliquerCritere();
      this.showFiltre = false;
    },
    getTypeEmplacement(type) {
      return TYPE_EMPLACEMENT.find((typeEmplacement) => {
        return typeEmplacement.name === type;
      }).libelle;
    },
    getDomaine(emplacement) {
      if (emplacement.type === ADRESSE) {
        return DOMAINE_EMPLACEMENT.find(domaine => {
          return domaine.name === emplacement.emplacementAdresse.domaine;
        }).libelle;
      }
      return '';
    },
    selectAll() {
      this.allEmplacementSelected = !this.allEmplacementSelected;
      this.emplacements.forEach((el) => {
        el.selected = this.allEmplacementSelected;
      });
      this.emplacementSelectionne = this.allEmplacementSelected;
    },
    selectionEmplacement() {
      this.emplacementSelectionne = this.emplacements.filter((el) => {
        return el.selected;
      }).length > 0;
    },
    getDataBody() {
      return {
        query: {
          societeId: this.societeActiveId,
        },
      };
    },
    getSelectionState(selection) {
      const emplacementsSelected = this.selection.emplacements.find(e => e.id === selection.id);
      if (!emplacementsSelected) return this.constantes.SELECTION_STATE.UNSELECTED;

      if (this.selection.dispositifs
        .filter(d => d.emplacementId === selection.id).length === selection.dispositifs.length
        || this.typePatrimoineSelected === this.constantes.EMPLACEMENT) {
        return this.constantes.SELECTION_STATE.SELECTED;
      }
      return this.constantes.SELECTION_STATE.SELECTED_PARTIALLY;
    },
    getSelectionButtonColor(selection) {
      return getSelectionColor(this.getSelectionState(selection));
    },
    getSelectionButtonMessage(selection) {
      return getSelectionMessage(this.getSelectionState(selection));
    },
    isInSelection(row) {
      return this.selection.emplacements.find(f => f.id === row.id);
    },
    manageAllInSelection() {
      if (this.allInSelection) {
        this.$emit('removeSelection', this.emplacements);
      } else {
        this.$emit('addSelection', this.emplacements);
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    changeRoute(routeName, idEmplacement) {
      if (routeName) {
        return this.$router.push({
          name: routeName,
          params: {
            id: idEmplacement,
          },
        });
      } return this.inProgress();
    },
    makeRechercheFilter(critereUpdate) {
      this.critereRecherche = critereUpdate;
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    switchDetailEmplacement(emplacement) {
      let routeName = null;
      switch (emplacement.type) {
        case ADRESSE:
          routeName = 'c.gabed.emplacement-adresse';
          break;
        case PARKING:
          routeName = 'c.gabed.emplacement-parking';
          break;
        case CENTRE_COMMERCIAL:
          routeName = 'c.gabed.emplacement-centreCommercial';
          break;
        case LIGNE_BUS:
          routeName = 'c.gabed.emplacement-ligneBus';
          break;
        case CLIENT:
          routeName = 'c.gabed.emplacement-client';
          break;
        default:
          routeName = 'home';
      }
      return routeName;
    },
    modificationEmplacement(emplacementInformation) {
      let routeName;
      switch (emplacementInformation.type) {
        case ADRESSE:
          routeName = 'm.gabed.emplacement-adresseModification';
          break;
        case PARKING:
          routeName = 'm.gabed.emplacement-parkingModification';
          break;
        case CENTRE_COMMERCIAL:
          routeName = 'm.gabed.emplacement-centreCommercialModification';
          break;
        case LIGNE_BUS:
          routeName = 'm.gabed.emplacement-ligneBusModification';
          break;
        case CLIENT:
          routeName = 'm.gabed.emplacement-clientModification';
          break;
        default:
          routeName = null;
      }
      this.changeRoute(routeName, emplacementInformation.id);
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    async goToTree(emplacement) {
      await this.$router.push({
        name: 'c.gabed.emplacement-detailEmplacement',
        params: { id: emplacement.id },
      });
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    updateAgenceAndRecherche() {
      this.critereRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.recherche();
    },
    showPopUpArchivage(emplacementToArchive) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.openPopUpPrevention = true;
      this.emplacementToArchive = emplacementToArchive;
    },
    async archiverEmplacement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await archiver(this.emplacementToArchive.id, this.emplacementToArchive.actif);
        messageSucces(this.$i18n.t('emplacement.messages.success.' + (this.emplacementToArchive.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpPrevention = false;
        this.emplacementToArchive = null;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validationEmplacement(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    showPopUpSuppression(emplacementToDelete) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.openPopUpPreventionSuppression = true;
      this.emplacementToDelete = emplacementToDelete;
    },
    async supprimerEmplacement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await supprimer(this.emplacementToDelete.id);
        messageSucces(this.$i18n.t('emplacement.messages.success.suppression'));
        this.openPopUpPreventionSuppression = false;
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      if (this.$route.params.tiersId) {
        const client = (await get(this.$route.params.tiersId)).data.result;
        this.critereRecherche.clients = [client];
      }
      if (this.moduleSecteurActive) {
        const targetSecteur = await getSecteursByIds(this.user.secteursId, PATRIMOINE);
        if (targetSecteur.length > 0) {
          this.critereRecherche.secteurs = targetSecteur.map(ts => ts.id);
        }
      }
      this.critereRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.mountedLoadingEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
